package music.jammers.client.shared.component

import androidx.compose.ui.graphics.Color

val primaryDark = Color(color = 0xFFF0F0F0)
val onPrimaryDark = Color(color = 0xFF571E1A)
val primaryContainerDark = Color(color = 0xFF73332F)
val onPrimaryContainerDark = Color(color = 0xFFFFDAD6)
val secondaryDark = Color(color = 0xFFE7BDB8)
val onSecondaryDark = Color(color = 0xFF442927)
val secondaryContainerDark = Color(color = 0xFFF0F0F0)
val onSecondaryContainerDark = Color(color = 0xFF979797)
val tertiaryDark = Color(color = 0xFFE1C38C)
val onTertiaryDark = Color(color = 0xFF3F2D04)
val tertiaryContainerDark = Color(color = 0xFF584419)
val onTertiaryContainerDark = Color(color = 0xFFFEDEA6)
val errorDark = Color(color = 0xFFFFB4AB)
val onErrorDark = Color(color = 0xFF690005)
val errorContainerDark = Color(color = 0xFF93000A)
val onErrorContainerDark = Color(color = 0xFFFFDAD6)
val backgroundDark = Color(color = 0xFF272626)
val onBackgroundDark = Color(color = 0xFFF1DEDC)
val surfaceDark = Color(color = 0xFF1A1110)
val onSurfaceDark = Color(color = 0xFFF1DEDC)
val surfaceVariantDark = Color(color = 0xFF003DA5)
val onSurfaceVariantDark = Color(color = 0xFFD8C2BF)
val outlineDark = Color(color = 0xFFF4F4F4)
val outlineVariantDark = Color(color = 0xFF534341)
val scrimDark = Color(color = 0xFF000000)
val inverseSurfaceDark = Color(color = 0xFFF1DEDC)
val inverseOnSurfaceDark = Color(color = 0xFF392E2D)
val inversePrimaryDark = Color(color = 0xFF904A44)
val surfaceDimDark = Color(color = 0xFF1A1110)
val surfaceBrightDark = Color(color = 0xFF423735)
val surfaceContainerLowestDark = Color(color = 0xFF140C0B)
val surfaceContainerLowDark = Color(color = 0xFF231918)
val surfaceContainerDark = Color(color = 0xFF271D1C)
val surfaceContainerHighDark = Color(color = 0xFF322826)
val surfaceContainerHighestDark = Color(color = 0xFF3D3231)

val iconTintLight = Color(color = 0xF4F4F4)
val cardTextLight = Color(color = 0xFFF4F4F4)

val iconTintDark = Color(color = 0x272626)
val cardTextDark = Color(color = 0xFF272626)

val optionalInstrumentColor = Color(color = 0xFFFFC058)

private const val SHORT_COLOR_LENGTH = 7
private const val LONG_COLOR_LENGTH = 9
private const val RGB_COLOR_MASK = 0x00000000ff000000

fun String.toColor(): Color {
    require(this[0] == '#') {
        "Unknown color"
    }

    var colorARGB = this.substring(1).toLong(radix = 16)
    if (this.length == SHORT_COLOR_LENGTH) {
        colorARGB = colorARGB or RGB_COLOR_MASK
    } else {
        require(this.length == LONG_COLOR_LENGTH) {
            "Unknown color"
        }
    }

    return Color(
        alpha = (colorARGB.shr(bitCount = 24) and 0xFF).toInt(),
        red = (colorARGB.shr(bitCount = 16) and 0xFF).toInt(),
        green = (colorARGB.shr(bitCount = 8) and 0xFF).toInt(),
        blue = (colorARGB.shr(bitCount = 0) and 0xFF).toInt(),
    )
}